import { Typography } from '@mui/material';

import Page from './components/Page';


export default function NotAllowedPage() {
    return (
        <Page header="You don’t have permission to view this page">
            <Typography>
                Click an item on the menu to find what you're looking for.
            </Typography>
        </Page>
    );
}
